export const ShareThinIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.75 6.893v2.734c0 .068-.045.123-.102.123H1.352c-.056 0-.102-.055-.102-.123V6.893" stroke="currentColor" strokeWidth=".8" strokeMiterlimit="6.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 8.125v-6.25m0-.625L3.652 3.649M6 1.25l2.348 2.399" stroke="currentColor" strokeWidth=".8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
